import { render, staticRenderFns } from "./SemicircleChart.vue?vue&type=template&id=5b21c50e"
import script from "./SemicircleChart.vue?vue&type=script&lang=js"
export * from "./SemicircleChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports